import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=arrow+me&selected=Material+Symbols+Rounded:arrow_menu_close:FILL@0;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const ArrowMenuCloseIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Arrow Menu Close Icon</title>;
    t1 = <path d="M10.0345 15.525L7.18075 12.6328C7.00642 12.4519 6.91925 12.241 6.91925 12C6.91925 11.759 7.00642 11.5481 7.18075 11.3672L10.0345 8.475C10.182 8.32117 10.3478 8.28258 10.5318 8.35925C10.7158 8.43592 10.8078 8.58158 10.8078 8.79625V15.2135C10.8078 15.4243 10.7158 15.5674 10.5318 15.6427C10.3478 15.7181 10.182 15.6788 10.0345 15.525ZM13 19.75V4.25C13 4.0375 13.0719 3.85942 13.2158 3.71575C13.3596 3.57192 13.5378 3.5 13.7503 3.5C13.9629 3.5 14.141 3.57192 14.2845 3.71575C14.4282 3.85942 14.5 4.0375 14.5 4.25V19.75C14.5 19.9625 14.4281 20.1406 14.2843 20.2843C14.1404 20.4281 13.9623 20.5 13.7498 20.5C13.5371 20.5 13.359 20.4281 13.2155 20.2843C13.0718 20.1406 13 19.9625 13 19.75Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};